import { StrategyDetailsPageListDocumentRecordsQuery } from '@/__generated__/graphql';
import Tag from '@/components/basicComponents/tag';
import { updatesTableColumnsEditMode } from '@/components/managerUpdates-page/constants';
import { getManagerUpdateName, getTagStyleType } from '@/components/managerUpdates-page/utils';
import DropdownActions from '@/components/table/dropdownActions';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { IItems } from '@/components/table/types';
import { dateFormatter } from '@/shared/utils/date';
import { DocumentRecordStatus } from '@trace-8/trace8-schema';
import { format } from 'date-fns';

interface TableBodyProp {
  tableData: StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'];
  dropdownActions: (row: StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'][number]) => IItems[];
  openEditManagerUpdatePage: (updateId: string) => void;
}

export const TableBody = ({ tableData, dropdownActions, openEditManagerUpdatePage }: TableBodyProp) => {
  return (
    <>
      {tableData.map((row) => (
        <TableRowWrapper key={row.id}>
          <TableRowCell width={updatesTableColumnsEditMode[0].width}>
            <RedirectTitleCell onClick={() => openEditManagerUpdatePage(row.id)}>
              {getManagerUpdateName(row.documentRecordFieldAnswers, row.name)}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={updatesTableColumnsEditMode[1].width}>
            <TextCell>{`${row?.owner?.firstName ?? ''} ${row?.owner?.lastName ?? ''}`}</TextCell>
          </TableRowCell>
          <TableRowCell width={updatesTableColumnsEditMode[2].width}>
            <TextCell>{row.statusUpdatedAt && dateFormatter(format(new Date(row.statusUpdatedAt), 'yyyy-MM-dd'), 'yyyy-MM-dd')}</TextCell>
          </TableRowCell>
          <TableRowCell width={updatesTableColumnsEditMode[3].width}>
            <TextCell>{DocumentRecordStatus[row.status]}</TextCell>
          </TableRowCell>
          <TableRowCell width={updatesTableColumnsEditMode[4].width}>
            <TextCell>
              {row?.sentimentFlag && row?.sentimentFlagLabel ? (
                <Tag title={row?.sentimentFlagLabel} size="sm" styleType={getTagStyleType(row?.sentimentFlag)} />
              ) : (
                '--'
              )}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={updatesTableColumnsEditMode[5].width}>
            <DropdownActions items={dropdownActions(row)} />
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};
